import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ListaFeirasMensagem, ListaMensagem } from '../models/mensagem.model';

@Injectable({
  providedIn: 'root'
})
export class MesangemService {
  private _apiUrl = environment.apiUrl + "/v1/MensagemHistorico";

  constructor(private http: HttpClient) { }

  consultaListaDeFeiras(clienteId: string) {

    let params = new HttpParams().set('ClienteId', clienteId)

    return this.http.get<ListaFeirasMensagem[]>(`${this._apiUrl}/listar-feiras`, { params });
  }

  consultaListaDeMensagensFeiras(clienteId: string, historicoMensagemId: string ) {

    let params = new HttpParams()
    .set('ClienteId', clienteId)
    .set('HistoricoMensagemId', historicoMensagemId)
    return this.http.get<ListaMensagem[]>(`${this._apiUrl}/listar-mensagens`, { params });
  }

  adicionarMensagem(payload: { clienteId: string; feiraClienteId: string; mensagem: string; mensagemRelevante: boolean }) {
    return this.http.post(`${this._apiUrl}`, payload);
  }
}